<template>
  <div style="padding: 0 20px;" v-if="places">
    <p><small><b>{{ getTranslation({ es: 'Lugares', en: 'Places' }, locale) }}</b></small></p>
    <v-chip
      v-for="(item, index) of places"
      :key="index"
      class="ma-2"
      :close="selectedPlaces.indexOf(item.ID) >= 0"
      :color="selectedPlaces.indexOf(item.ID) >= 0 ? item.Color : '#CCCCCC'"
      @click:close="handleClose(item.ID)"
      @click="selectedPlaces.push(item.ID)"
      :dark="getIsDark(selectedPlaces.indexOf(item.ID) >= 0 ? item.Color : '#CCCCCC')"
      small
    >
    {{ getTranslation(item.Name, locale) }}
    </v-chip>
  </div>
</template>
<script>
import axios from 'axios'
import tinycolor from 'tinycolor2'
import utils from '@/services/utils'
export default {
   props: {
      dtouchWorkspace: {
         type: String,
         required: true,
      },
      content: {
         type: Object,
         required: true,
      },
      locale: {
         type: String,
         default: 'es',
      },
      onChange: {
         type: Function,
         required: true,
      },
   },
   data: () => ({
      places: null,
      selectedPlaces: [],
   }),
  computed: {
    showWorkspaces () {
      return ['72c0948f-7eef-4d82-ab84-f94862c7a37f', '35b4c51b-c3b2-4b6a-8f52-7e68244d72a7']
    },
  },
   watch: {
      'content.BookingActWorkspaceID' () {
         this.handleGetData()
      },
      selectedPlaces () {
         this.onChange(this.selectedPlaces)
      },
   },
   mounted () {
      this.handleGetData()
   },
   methods: {
      getIsDark (v) {
         return tinycolor(v).isLight() ? false : true
      },
      getTranslation (v, locale) {
         return utils.getTranslation(v, locale)
      },
      handleGetData () {
         this.places = null
        if (this.showWorkspaces.indexOf(this.dtouchWorkspace) < 0) return

         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_DTOUCH}/v1/public/cm/${this.dtouchWorkspace}/places/`
         axios.get(url)
            .then((response) => {
               //console.log('response', response)
               if (!response || !response.data) return
               this.places = response.data.filter(x => !this.content.BookingActWorkspaceID || x.WorkspaceID === this.content.BookingActWorkspaceID).map(item => {
                  item.Color = item.Color ? item.Color : '#000000'
                  item.Name = item.Name || item.Address || item.ID
                  return item
               })
            })
            .catch((error) => {
               console.log(error)
            })
            .then(() => {
               this.loading = false
            })
      },
      handleClose (v) {
         this.selectedPlaces = this.selectedPlaces.filter(x => x !== v)
      },
   },
}
</script>

